goog.provide('el8.appchart.refpanel.uploadPtPhoto');

goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.FileUploader');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.refpanel.uploadPtPhoto');
goog.require('el8.util.amplitude.helpers');

el8.appchart.refpanel.uploadPtPhoto = (function() {

    var IMG_HEIGHT = 300;
    var IMG_WIDTH = IMG_HEIGHT;

    var $refpanelPhoto = $('.pt-profile-photo-section', $('#refBoard'));
    var fileUploader;

    var that = new el8.uiwidget.NewDialog({
        title: '',
        contentFn: el8.template.appchart.refpanel.uploadPtPhoto.content,
        width: IMG_WIDTH,
        autoHeight: true,
        position: 'center',
        showXButton: true
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton('change', 'Upload Photo...', function() {
        $('.photo-section', that.getContentElt()).find('input').click();
    }, false);
    buttonSet.addButton('remove', 'Remove Photo', deletePhoto, false);
    that.setButtonSet(buttonSet);


    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        var $uploadContainer = $('.photo-section', that.getContentElt());
        fileUploader = new el8.uiwidget.FileUploader({
            container: $uploadContainer,
            isImageUpload: true,
            droppableArea: $uploadContainer,
            url: el8.service.urls.get('uploadPatientPhoto'),
            droppableZoneClass: 'el8UploadDroppableProfilePic',
            inputWidth: IMG_WIDTH,
            inputHeight: IMG_HEIGHT,
            success: function() {
              refreshImages();
              el8.util.amplitude.logEvent('upload patient photo');
            }
        });
        $uploadContainer.prepend(fileUploader.getUploadFormContents());
        that.getContentElt().removeClass('el8OverflowAuto').addClass('hideOverflow');

        $('img', $uploadContainer).on('load', function() {
            that.adjustPosition();
        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        var imgUrl = el8.service.urls.get('fetchPatientPhoto', [IMG_WIDTH, IMG_HEIGHT]);
        $('.photo-section', that.getContentElt()).find('img').attr('src', imgUrl);
        fileUploader.show();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        fileUploader.hide();
    };

    // hack to guarantee that the dialog is no bigger than the image
    that._getInnerContentHeight = function() {
        return IMG_HEIGHT;
    };

    function refreshImages() {
        var $uploadContainer = $('.photo-section', that.getContentElt());
        var $imgs = [
            $('img', $refpanelPhoto),
            $('img', $uploadContainer)
        ];
        $imgs.forEach(function($img) {
            var url = $img.attr('src');
            var queryParamIndex = url.indexOf('?');
            if (queryParamIndex !== -1) { url = url.substring(0, queryParamIndex); }
            // need to bust the cache to refresh the image
            url += '?r=' + Math.random();
            $img.attr('src', url);
        });
    }

    function deletePhoto() {
        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('uploadPatientPhoto'),
            success: refreshImages
        });
    }

    return that;

})();
